// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"68":"9f41231c","219":"9f41231c","271":"9f41231c","508":"9f41231c","700":"9f41231c","737":"9f41231c"}[chunkId] + ".chunk.css";
};